import { Logo as UnstyledLogo } from 'components/Logo';
import styled, { css, DefaultTheme } from 'styled-components';
import { Col } from 'components/GridSystem';

type VariantProps = {
  variant: 'primary' | 'secondary';
};

const copyrightTextModifiers = (theme: DefaultTheme) => ({
  primary: css`
    color: ${theme.colors.neutralDark80};
  `,
  secondary: css`
    color: ${theme.colors.globalWhite100};
  `,
});

const borderColors: Record<string, keyof DefaultTheme['colors']> = {
  primary: 'neutralDark20',
  secondary: 'neutralDark80',
};

export const Wrapper = styled.header<VariantProps>`
  ${({ theme, variant }) => css`
    display: flex;
    align-items: center;
    min-height: 10.4rem;
    width: 100%;

    padding: 0 2.8rem;
    border-bottom: 1px solid ${theme.colors[borderColors[variant]]};

    @media screen and (max-width: 1024px) {
      min-height: 6.2rem;
      height: 6.2rem;
    }
  `};
`;

export const Logo = styled(UnstyledLogo)`
  width: 230px;
  object-fit: contain;

  @media screen and (max-width: 1024px) {
    width: 154px;
  }
`;

export const RightCol = styled(Col)`
  display: flex;
  align-items: center;
  justify-content: flex-end;
`;

export const CopyrightText = styled.p<VariantProps>`
  ${({ variant, theme }) => css`
    ${copyrightTextModifiers(theme)[variant]}

    font-size: 1.2rem;
    margin-bottom: 0;

    @media screen and (max-width: 1024px) {
      display: none;
    }
  `};
`;
